import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../molecules/DashboardLayout";
import SectionHeader from "../../../molecules/SectionHeader";
import AddSubType from "../components/Modals/AddSubType";
import Panel from "../../../molecules/Panel";
import { Popup } from "../../../atoms/Popup";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Row, Col, Typography, Space, Radio, message, Spin } from "antd";
import AddMaintanence from "../components/Modals/AddMaintenance";
import UpdateServices from "../components/Modals/UpdateServices";
import { useDispatch, useSelector } from "react-redux";
import { getMaintenanceTypes, setEmptyMaintenanceTypes } from "../ducks/actions";
import { maintenanceService } from "../../../../configs/constants";
import axios from "../../../../utils/axiosInceptor";

const { Title } = Typography;

export default () => {
  const dispatch: any = useDispatch();

  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [addSubCat, setAddSubCat] = useState(0);
  const [childDetail, setChildDetails] = useState();
  const [parentID, setParentID] = useState();
  const [parentKey, setParentKey] = useState(0);
  const [childKey, setChildKey] = useState();
  const [afterUpdate, setAfterUpdate] = useState(false);
  const [subTicketList, setSubTicketList] = useState([]);
  const [categoryRoot, setCategoryRoot] = useState([]);
  const [loader, setLoader] = useState(false);
  const [switchVal, setSwitchVal] = useState(null);
  const categoryData = useSelector((state: any) => state.configuration.maintenanceTypes);
  const [defaultActive, setDefaultActive] = useState(true);
  const [orgId, setOrgId] = useState<string | null>(null);

  const [type, setType]: any = useState("RES");

  const [onClose, setOnClose] = useState(false);

  useEffect(() => {
    const loginResponse = window.localStorage.getItem("login-response");
    if (loginResponse) {
      try {
        const parsed = JSON.parse(loginResponse);
        setOrgId(parsed?.orgId ?? null);
      } catch (err) {
        console.error("Invalid login-response in localStorage", err);
      }
    }
  }, []);

  useEffect(() => {
    dispatch(getMaintenanceTypes());
    return () => {
      dispatch(setEmptyMaintenanceTypes());
      setCategoryRoot([]);
      setSubTicketList([]);
    };
  }, []);

  useEffect(() => {
    if (afterUpdate) {
      switch (type) {
        case "RES":
          setCategoryRoot(categoryData?.residentialCategories);
          break;
        case "COM":
          setCategoryRoot(categoryData?.commercialCategories);
          break;
        case "INT":
          setCategoryRoot(categoryData?.internalCategories);
          break;
        default:
          setCategoryRoot(categoryData?.residentialCategories);
      }
    } else {
      const residentialCategories = categoryData?.residentialCategories;
      residentialCategories?.length > 0 && setCategoryRoot(residentialCategories);
    }
  }, [categoryData]);

  useEffect(() => {
    setSubTicketList(filterSubData(categoryRoot?.[parentKey]?.subCategories));
  }, [parentKey, categoryRoot]);

  const showModal = (param) => {
    setTrigger(param);
    setVisible(true);
  };

  const filterData = () => {
    if (categoryRoot && categoryRoot?.length > 0)
      return categoryRoot.map((item, index) => ({
        id: item.categoryId,
        title: item.categoryName,
        subCategories: item.subCategories,
        categoryId: item.categoryId,
        categoryName: item.categoryName,
      }));
  };

  const onUpdate = () => {
    setAfterUpdate(true);
    dispatch(getMaintenanceTypes());
  };

  const onCancel = () => {
    setVisible(false);
  };
  const popup = [
    {
      title: (
        <Title level={3} className="ag-white mb-0">
          Update Maintenance Type
        </Title>
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="ag-white mb-0">
          {`${addSubCat === 1 ? "Update" : "Add"} Maintenance Sub-Type`}
        </Title>
      ),
      content: (
        <UpdateServices
          childDetail={childDetail}
          categoryType={type}
          parentKey={parentKey}
          setVisible={setVisible}
          childKey={childKey}
          categoryRoot={categoryRoot}
          onUpdate={onUpdate}
          addSubCat={addSubCat}
          type="subtype"
        />
      ),
      width: 850,
      style: { padding: 8 },
    },
    {
      title: (
        <Title level={3} className="ag-white mb-0">
          Add Maintenance Type
        </Title>
      ),
      content: (
        <AddMaintanence
          onClose={onClose}
          setOnClose={setOnClose}
          visible={visible}
          setVisible={setVisible}
          selected={categoryData}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="ag-white mb-0">
          Add Maintenance Sub-Type
        </Title>
      ),
      content: <AddSubType onClose={onClose} setOnClose={setOnClose} setVisible={setVisible} />,
      width: 850,
    },
  ];

  const popupProps = {
    destroyOnClose: true,
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    style: popup[trigger].style,
    className: "config-modal-width",
    onCancel: () => onCancel(),
  };

  const filterSubData = (data) => {
    if (data && data?.length > 0)
      return data.map((item) => ({
        id: item.subCategoryId,
        title: item.name,
        timeInMin: item.timeInMin,
        subCategoryId: item.subCategoryId,
        vat: item?.vat,
        amount: item?.amount,
        paid: item?.paid,
        minimumAdvanceNotice: item?.minimumAdvanceNotice ? item?.minimumAdvanceNotice : 0,
        isEnabled: item?.isEnabled,
        priceUnit: item?.priceUnit,
        name: item.name,
      }));
  };

  const getItemDetails = (item, type) => {
    setParentID(item?.categoryId);
    if (item?.index != null && item?.index != undefined) setParentKey(item?.index);
  };

  const getCurrentSelect = (item) => {
    setChildDetails(item);
    setChildKey(item?.index);
  };

  const patchShowHideCall = async (e, i, id) => {
    setLoader(true);
    if (e) {
      setSwitchVal(id);
    } else {
      setSwitchVal(null);
    }
    let categoryRootData = categoryRoot;

    if (parentKey != null && categoryRootData?.length > 0) {
      if (categoryRootData[parentKey]?.subCategories?.length > 0) {
        categoryRootData[parentKey].subCategories[i].isEnabled = e;
        setCategoryRoot(categoryRootData);
      }
    }

    if (!orgId) {
      message.error("Organization ID Not Found. Please Reload.");
      setLoader(false);
      return;
    }

    try {
      let url = `${maintenanceService}/serviceprovider/category/${orgId}`;

      let postData = {
        [type === "RES" ? "residentialCategories" : type === "COM" ? "commercialCategories" : "internalCategories"]:
          categoryRootData,
      };
      await axios.patch(url, postData);
      setTimeout(() => {
        setLoader(false);
        message.success(
          e
            ? `Enabled ${categoryRootData[parentKey].subCategories[i].name} Successfully`
            : `Disabled ${categoryRootData[parentKey].subCategories[i].name} Successfully`
        );
        onUpdate();
      }, 800);
    } catch (e) {
      setLoader(false);
      const { response } = e;
      message.error(response?.data?.message);
    }
  };

  useEffect(() => {
    switch (type) {
      case "RES":
        setCategoryRoot(categoryData?.residentialCategories);
        break;
      case "COM":
        setCategoryRoot(categoryData?.commercialCategories);
        break;
      case "INT":
        setCategoryRoot(categoryData?.internalCategories);
        break;
      default:
        setCategoryRoot(categoryData?.residentialCategories);
    }
  }, [type]);

  const onTabChange = (e) => {
    setDefaultActive(true);
    setType(e);
  };
  return (
    <>
      <DashboardLayout>
        <SectionHeader noborder={true} heading="Categories" />
        <Row gutter={[24, 32]}>
          <Col span={24}>
            <Row gutter={24}>
              <Col xl={24}>
                <Row gutter={24}>
                  <Col span={12}>
                    <Radio.Group defaultValue="RES" buttonStyle="solid" onChange={(e) => onTabChange(e.target.value)}>
                      <Space size={12}>
                        <Radio.Button value="RES">Residential</Radio.Button>
                        <Radio.Button value="COM">Commercial</Radio.Button>
                        <Radio.Button value="INT">Internal</Radio.Button>
                      </Space>
                    </Radio.Group>
                  </Col>
                  <Col span={12}>
                    <Row justify="end" className="mb-1">
                      <Button size="large" type="primary" onClick={() => showModal(2)}>
                        Add Maintenance Type <PlusOutlined />
                      </Button>
                    </Row>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Panel
                      ticketlist={filterData()?.length > 0 ? filterData() : []}
                      setVisible={setVisible}
                      setTrigger={setTrigger}
                      panelName="maintenance"
                      category="Maintenance Types"
                      getItemDetails={getItemDetails}
                      count={categoryRoot?.length ? categoryRoot?.length : 0}
                      categoryRoot={categoryRoot}
                      parentKey={parentKey}
                      type={type}
                      orgId={orgId}
                      onUpdate={onUpdate}
                      parentID={parentID}
                      setDefaultActive={setDefaultActive}
                      defaultActive={defaultActive}
                    />
                  </Col>
                  <Col span={12}>
                    {loader ? (
                      <Row gutter={[24, 24]}>
                        <Col span={24}>
                          <Space size={24} className="w-100 text-center" direction="vertical">
                            <Spin size="large" className="ag-fontSize32" />
                          </Space>
                        </Col>
                      </Row>
                    ) : (
                      <Panel
                        ticketlist={subTicketList?.length > 0 ? subTicketList : []}
                        setVisible={setVisible}
                        setTrigger={setTrigger}
                        category="Sub-Types"
                        count={subTicketList?.length ? subTicketList?.length : 0}
                        getItemDetails={getItemDetails}
                        getCurrentSelect={getCurrentSelect}
                        setAddSubCat={setAddSubCat}
                        panelName="sub_type"
                        isAction={true}
                        callApiWithShowHideData={(e, i, id) => patchShowHideCall(e, i, id)}
                        switchVal={switchVal}
                        categoryRoot={categoryRoot}
                        parentKey={parentKey}
                        type={type}
                        orgId={orgId}
                        onUpdate={onUpdate}
                        parentID={parentID}
                        setDefaultActive={setDefaultActive}
                        defaultActive={defaultActive}
                      />
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup {...popupProps} />
    </>
  );
};
